import React, { useState, useEffect, useRef } from "react";
import "./production.css";
import bottleImage from "../../../../../assets/production-new.webp";

const Chart = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = '100%';
              setWaterPercentage(waterHeight);
            }, 300);

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="career-chart-section" ref={chartSectionRef}>
      <div className="career-male-1-container">
        <div className="career-male-1">
          <img className="career-male-1-image" src={bottleImage} alt="Bottle" />
          <div
            className="career-male-1-water"
            style={{ height: waterPercentage }}
          />
        </div>
      </div>
    </div>
  );
};

export default Chart;
